import { useConfigStore } from '~/store/useConfigStore'
import type { Config } from '~/types'
import { useHandleException } from '~/composables/useHandleException'

export const useIntegrations = () => {
  const { info } = console
  const config = useConfigStore()

  const integrationMap: Record<keyof Config.Integrations, any> = {
    intercom: useIntercomCom,
    termlyIo: useTermlyIo,
  }

  const init = () => {
    const { integrations } = config.$state

    Object.keys(integrations).forEach((key) => {
      if (key in integrationMap) {
        const callback = integrationMap[key as keyof Config.Integrations]
        const settings = integrations[key as keyof Config.Integrations]

        info(`Integration ${key}`, settings)

        if (typeof callback === 'function') {
          try {
            callback(settings)
          }
          catch (ex: unknown) {
            useHandleException(new Error(`Integration ${key} error: ${ex}`))
          }
        }
      }
      else {
        useHandleException(new Error(`Integration ${key} does not found`))
      }
    })
  }

  init()

  return {
    init,
  }
}
